import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { store } from 'redux/storeConfig/store';
import * as authSelectors from '../../../../redux/reducers/auth';
import API_BASE_URL from '../../../../redux/sagas/settings/apibaseurl';
import * as alerts from '../../../../redux/utils/alerts';
import { appIntl } from '../../../../utility/context/IntlGlobalProvider';
import * as entitySelectors from '../../Entities/reducers';

import * as actions from '../actions';
import * as selectors from '../reducers';
import * as schemas from '../schemas';
import * as types from '../types';
import { camelize } from 'utility/Utils';
import {
  getSystemNotificationsListService,
  getUserNotificationsListService,
  markUserNotificationsAsReadService
} from '../services';

/* -------------------------------------------------------------------------- */
/*                         FETCH USER NOTIFICATIONS LIST                      */
/* -------------------------------------------------------------------------- */
function* fetchUserNotificationsList(action) {
  const { operatorId, organizationId } = action.payload;

  // const { operatorId, organizationId } = yield select(authSelectors.getAuthUserMembershipFilters, {
  //   filterOperatorId,
  //   filterOrganizationId
  // });
  console.log('operatorId', operatorId);
  console.log('organizationId', organizationId);
  if (operatorId && organizationId) {
    getUserNotificationsListService(
      { operatorId, organizationId },
      {
        successAction: (response) => {
          const resultData = response.data.map((result) => camelcaseKeys(result));
          const {
            entities: { userNotifications },
            result
          } = normalize(resultData, schemas.userNotifications);
          store.dispatch(actions.completeFetchingUserNotifications(userNotifications, result));
        },
        errorAction: (error) => {
          store.dispatch(actions.failFetchingUserNotifications(error));
        }
      }
    );
  }
}

export function* watchFetchUserNotificationsList() {
  yield takeEvery(types.USER_NOTIFICATIONS_FETCH_STARTED, fetchUserNotificationsList);
}

/* -------------------------------------------------------------------------- */
/*                             PARTIAL FETCH LIST                             */
/* -------------------------------------------------------------------------- */
function* partialFetchUserNotificationsList(action) {
  const {
    entityTypeId,
    operatorId: filterOperatorId,
    organizationId: filterOrganizationId
  } = action.payload;
  const date = yield select(entitySelectors.getUserUpdateByEntityDate, entityTypeId);
  const { operatorId, organizationId } = yield select(authSelectors.getAuthUserMembershipFilters, {
    filterOperatorId,
    filterOrganizationId
  });

  getSystemNotificationsListService(
    { operatorId, organizationId },
    {
      successAction: (response) => {
        const resultData = response.data.map((result) => camelcaseKeys(result));
        const {
          entities: { userNotifications },
          result
        } = normalize(resultData, schemas.userNotifications);
        store.dispatch(
          actions.completePartialFetchingUserNotifications(
            userNotifications,
            result,
            operatorId,
            organizationId
          )
        );
      },
      errorAction: (error) => {
        store.dispatch(actions.failPartialFetchingUserNotifications(error));
      }
    }
  );
}

export function* watchPartialFetchUserNotificationsList() {
  yield takeEvery(
    types.USER_NOTIFICATIONS_PARTIAL_FETCH_STARTED,
    partialFetchUserNotificationsList
  );
}

function* markAsReadUserNotifications(action) {
  const notificationIds = action.payload;

  markUserNotificationsAsReadService(
    { notificationIds: notificationIds.join(',') },
    {
      successAction: (response) => {
        const resultData = response.data.map((result) => camelcaseKeys(result));
        const resultIds = resultData.map((result) => result.notificationId);
        console.log('resultIds', resultIds);
        console.log('resultData', resultData);
        store.dispatch(
          actions.completeReadingUserNotification(
            resultData,
            resultData.map((result) => result.notificationId)
          )
        );
      },
      errorAction: (error) => {
        store.dispatch(actions.failReadingUserNotification(notificationIds));
      }
    }
  );
}

export function* watchMarkAsReadUserNotification() {
  yield takeEvery(types.USER_NOTIFICATION_READ_STARTED, markAsReadUserNotifications);
}
